import { ReactElement } from 'react';
import styles from './ui-sub-sidebar.module.scss';
import { NavLink, useLocation } from 'react-router';

export type UISubSidebarGroupProps = {
    title?: string;
    items: UISubSidebarItemProps[];
};

export type UISubSidebarItemProps = {
    text: string;
    link: string;
    additionalActiveLinkPaths?: string[];
};

export type UISubSidebarProps = {
    absolutePath?: string;
    groups: UISubSidebarGroupProps[];
};
export function UISubSidebar(props: UISubSidebarProps): ReactElement {
    const { absolutePath, groups } = props;
    return (
        <nav className={styles.container}>
            {groups.map((group, index) => (
                <div key={`group-${index}`} className={styles.groupContainer}>
                    {group.title && <HeaderItem title={group.title} />}
                    {group.items.map((item, index) => (
                        <Item
                            {...item}
                            key={`item-${index}`}
                            absolutePath={absolutePath}
                        />
                    ))}
                </div>
            ))}
        </nav>
    );
}

type HeaderItemProps = {
    title: string;
};
function HeaderItem(props: HeaderItemProps): ReactElement {
    const { title } = props;
    return (
        <div className={`${styles.itemContainer} ${styles.headerContainer}`}>
            <span style={{ marginLeft: 32 }}>{title}</span>
        </div>
    );
}

type INNER_UISubSidebarItemProps = UISubSidebarItemProps & {
    absolutePath?: string;
};
function Item(props: INNER_UISubSidebarItemProps): ReactElement {
    const { absolutePath, text, link, additionalActiveLinkPaths } = props;

    const location = useLocation();
    const pathOfThisPage = `${absolutePath}/${link}`;
    const startOfPathMatch =
        location.pathname.startsWith(pathOfThisPage) ||
        location.pathname === pathOfThisPage;

    const additionalPathsMatch = additionalActiveLinkPaths?.some((path) => {
        return location.pathname === path;
    });

    const isMatch = startOfPathMatch || !!additionalPathsMatch;

    return (
        <>
            <NavLink
                to={link}
                className={({ isActive }) => {
                    const active = isActive || isMatch;

                    return active
                        ? `${styles.itemContainer} ${styles.selected}`
                        : styles.itemContainer;
                }}
            >
                {isMatch && <div className={styles.selectedIndicator} />}
                <span style={{ marginLeft: 32 }}>{text}</span>
            </NavLink>
        </>
    );
}
